// extracted by mini-css-extract-plugin
module.exports = {"styledError":"ReactPlayground-StyledError-module--styled-error--I3xYq alert alert-danger text-monospace"};